// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bhn_vu bhn_ql bhn_va bhn_gy bhn_kg bhn_sv","ProfileAdminTools__item":"iz_b"};